import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BaseService} from './base.service';
import {Observable} from 'rxjs';
import {AlertService} from './alert.service';
import {GlobalService} from './global.service';
import {AppUrl} from '../constants/app-url';

@Injectable({
  providedIn: 'root'
})
export class CourierExecutiveService extends BaseService {
  constructor(public http: HttpClient,
              public alertService: AlertService,
              public globalService: GlobalService) {
    super(http, alertService, globalService);
  }

  get(data): Observable<any> {
    return this.getRequest(AppUrl.COURIER_EXECUTIVES(), data);
  }

  count(): Observable<any> {
    return this.getRequest(AppUrl.COURIER_EXECUTIVES_COUNT());
  }

  detail(id): Observable<any> {
    return this.getRequest(AppUrl.COURIER_EXECUTIVES(id));
  }

  create(data): Observable<any> {
    return this.postRequest(AppUrl.COURIER_EXECUTIVES(), data);
  }

  update(id, data): Observable<any> {
    return this.putRequest(AppUrl.COURIER_EXECUTIVES(id), data);
  }

  updatePassword(id, data): Observable<any> {
    return this.putRequest(AppUrl.COURIER_EXECUTIVE_PASSWORD(id), data);
  }

  updateStatus(id, data): Observable<any> {
    return this.putRequest(AppUrl.COURIER_EXECUTIVE_STATUS(id), data);
  }
}
